// Acronyms which are used in panel names, test names, etc,
// which we want to keep in uppercase.
const ACRONYMS = [
  'MRI', // magnetic resonance imaging
  'CT', // computed tomography
  'XRAY',
  'US', // ultrasound
  'DX', // diagnosis / diagnostic
  'PSA', // prostate-specific antigen
  'HPV', // human papillomavirus
  'FIT', // fecal immunochemical test
  'IO',
  'LCB', // liquid capillary blood
  'MTL', // Molecular Testing Labs (external lab partner)
  'USSL', // US Speciality Labs (external lab partner)
  'PREP', // pre-exposure prophylaxis
  'PGX',
  'BRCA',
  'HDR',
  'FH',
  'STI', // sexually transmitted infection
  'MR', // magnetic resonance
  'CAD', // computer-aided detection
  'GI', // gastrointestinal
  'LDL', // low-density lipoprotein
  'HDL', // high-density lipoprotein
];

// Proper names (like screening partners) that appear in enum values,
// whose casing we want to preserve.
const PROPER_NAMES: Record<string, string> = {
  HBA1C: 'HbA1c',
  SKINIO: 'SkinIO',
  WITH: 'with',
  'W/O': 'w/o',
  'AND/OR': 'and/or',
};

const formatPanelWord = (word: string): string => {
  const upperCaseWord = word.toUpperCase();
  if (PROPER_NAMES[upperCaseWord]) {
    return PROPER_NAMES[upperCaseWord];
  }

  const matched = ACRONYMS.findIndex((term) => upperCaseWord.replace(/\W/g, '') === term);
  if (matched !== -1) {
    return upperCaseWord;
  }

  if (ACRONYMS.includes(upperCaseWord)) {
    return upperCaseWord;
  }
  return upperCaseWord.charAt(0).toUpperCase() + upperCaseWord.slice(1).toLowerCase();
};

export const formatPanelTypeOrTestName = (value: string): string => {
  return value
    .replace(/_/g, ' ')
    .split(' ')
    .filter(Boolean) // Remove empty strings
    .map(formatPanelWord)
    .join(' ');
};
